module.exports = __webpack_public_path__ + "static/media/new_wanko.b5288018.jpeg";